import React, { useState } from "react";
import { Spinner } from "react-bootstrap";

const CartItemsList = ({
  cartItems = [],
  productImage,
  handleRemoveItemFromCart,
  onIncreaseQuantity,
  onDecreaseQuantity,
  updatingItems = [],
}) => {
  const [removingId, setRemovingId] = useState(null);

  const handleRemove = async (item) => {
    const itemId = item?._id || item?.id;
    if (!itemId) return;

    setRemovingId(itemId);
    try {
      await handleRemoveItemFromCart(item);
    } finally {
      setRemovingId(null);
    }
  };

  return (
    <div className="cart-items-container" role="list" aria-label="Cart items list">
      {Array.isArray(cartItems) &&
        cartItems.map((item) => {
          if (!item || !item.product) return null;

          const itemId = item._id || item.id;
          const isRemoving = removingId === itemId;
          const isUpdating = updatingItems.includes(itemId);

          return (
            <div
              key={itemId}
              role="listitem"
              className="cart-item relative"
            >
              {/* Full black overlay loader */}
              {isUpdating && (
                <div
                  className="absolute inset-0 bg-black bg-opacity-60 flex justify-center items-center z-50"
                >
                  <Spinner animation="border" variant="light" />
                </div>
              )}

              {/* Product Image */}
              <div className="cart-item-img">
                <img
                  src={productImage(item)}
                  alt={item.product.title}
                  loading="lazy"
                  onError={(e) => {
                    e.currentTarget.onerror = null;
                    e.currentTarget.src =
                      "https://storage.googleapis.com/workspace-0f70711f-8b4e-4d94-86f1-2a93ccde5887/image/9aa9337d-9c1a-466f-9770-50c28fc557a6.png";
                  }}
                />
              </div>

              {/* Product Details */}
              <div className="cart-item-details">
                <div className="cart-item-name">{item.product.title}</div>
                <div
                  className="quantity-controls"
                  aria-label={`Modify quantity for ${item.product.title}`}
                >
                  <button
                    aria-label={`Decrease quantity of ${item.product.title}`}
                    disabled={item.quantity <= 1 || isRemoving || isUpdating}
                    onClick={() => onDecreaseQuantity?.(item)}
                  >
                    –
                  </button>
                  <div className="quantity-display" aria-live="polite" aria-atomic="true">
                    {item.quantity}
                  </div>
                  <button
                    aria-label={`Increase quantity of ${item.product.title}`}
                    disabled={isRemoving || isUpdating}
                    onClick={() => onIncreaseQuantity?.(item)}
                  >
                    +
                  </button>
                </div>
              </div>

              {/* Price */}
              <div className="cart-item-price" aria-label={`Price for ${item.product.title}`}>
                ₹{item.product.discountedPrice * item.quantity}
              </div>

              {/* Remove Button */}
              <button
                className="remove-btn"
                aria-label={`Remove ${item.product.title} from cart`}
                title="Remove item"
                onClick={() => handleRemove(item)}
                disabled={isRemoving || isUpdating}
              >
                {isRemoving ? (
                  <Spinner animation="border" size="sm" variant="danger" />
                ) : (
                  "×"
                )}
              </button>
            </div>
          );
        })}

      {cartItems.length === 0 && (
        <p className="text-gray-500 italic text-center mt-4">
          Your cart is empty.
        </p>
      )}
    </div>
  );
};

export default CartItemsList;
